module.exports = __webpack_public_path__ + "img/元素2.f143a0c3.png";